import { FC, MouseEvent as ReactMouseEvent } from 'react'
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material'
import classNames from 'classnames'

import { Icon, IconName } from '../Icon'
import { Text } from '../Text'
import { Tooltip } from '../Tooltip'

import './index.scss'

export interface ButtonProps extends Omit<MuiButtonProps, 'onClick'> {
  extraWide?: boolean
  fluid?: boolean
  icon?: IconName
  onClick?: (event: ReactMouseEvent<HTMLElement, MouseEvent>) => void
  secondary?: boolean
  small?: boolean
  square?: boolean
  text?: string
  tooltipText?: string
  warning?: boolean
}

const Button: FC<ButtonProps> = ({
  className,
  fluid,
  icon,
  secondary,
  small,
  square,
  text,
  tooltipText,
  warning,
  extraWide,
  ...props
}) => {
  const button = (
    <MuiButton
      variant="text"
      disableElevation
      disableRipple
      className={classNames(
        'populus-button',
        secondary ? 'secondary' : 'primary',
        warning && 'warning',
        small ? 'small' : 'large',
        square && 'square',
        text && 'text',
        icon && 'icon',
        fluid && 'fluid',
        extraWide && 'extra-wide',
        className
      )}
      {...props}
    >
      {icon && <Icon icon={icon} color={secondary ? 'midnight-0' : 'white'} />}
      {text && (
        <Text
          className={classNames(icon && 'icon-text')}
          styleType={`button${secondary ? '-light' : ''}`}
        >
          {text}
        </Text>
      )}
    </MuiButton>
  )

  return tooltipText ? (
    <Tooltip content={tooltipText} dark mouseEnterDelay={500} orientation="top" trigger={button} />
  ) : (
    button
  )
}

export default Button
